module.exports = __webpack_public_path__ + "static/media/ill_ogoninflammation.724e81bc.svg";